import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { combineLatestWith, Observable, Subject } from 'rxjs';
import {
  AnswerDisplayAndSelectModel,
  DisplayAndSelectModel
} from '@bo-client/shared/components/display-and-selec-option/display-and-select.model';
import { uri } from '@bo-client/shared/constants/uri';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { MeteringConceptModel } from '@bo-client/activation-management/shared/models/meteringConceptModel';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';

@Component({
  selector: 'app-grid-registration-metering-concept',
  templateUrl: './grid-registration-metering-concept.component.html',
  styleUrls: ['./grid-registration-metering-concept.component.scss']
})
export class GridRegistrationMeteringConceptComponent implements OnInit, OnDestroy {
  private compUnsub$: Subject<void> = new Subject<void>();

  // eslint-disable-next-line no-empty-function
  constructor(private httpHapService: HttpHapService) {}

  @Input()
  meteringConceptFormControl: FormControl<number>;

  @Input()
  canUpdate$: Observable<boolean>;

  @Input()
  disable = false;

  @Input()
  catalogId = 'default';

  selectedOption$: Observable<DisplayAndSelectModel>;
  options$: Observable<DisplayAndSelectModel[]>;
  meteringConcepts$: Observable<MeteringConceptModel[]>;

  onSelectedOptionChanged($event: AnswerDisplayAndSelectModel) {
    this.meteringConceptFormControl.setValue($event.selectedItem.itemId);
  }

  ngOnInit(): void {
    this.meteringConcepts$ = this.httpHapService.get(uri.cmGetAllMeteringRequest);
    this.options$ = this.meteringConcepts$.pipe(
      map((x) => x.filter((y) => y.catalogId === this.catalogId)),
      map((x) => {
        // map MeteringConceptModel to DisplayAndSelectModel
        return x.map((y) => {
          return {
            itemId: y.id,
            displayName: y.name,
            description: y.description,
            imgUrl: y.imageDocument.url
          };
        });
      })
    );

    this.selectedOption$ = this.options$.pipe(
      combineLatestWith(
        this.meteringConceptFormControl.valueChanges.pipe(startWith(this.meteringConceptFormControl.value))
      ),
      takeUntil(this.compUnsub$),
      map(([options, formControlValue]) => {
        return options.find((option) => option.itemId === formControlValue);
      })
    );
  }

  ngOnDestroy(): void {
    this.compUnsub$.next();
  }
}
